<template>
    <div>
        <trial-end-clock
            :title="$t.__('common.labels.inactive_account')"
            :subtitles="[$t.__('pages.errors.TrialEndCartExpired.thanks_contact_us')]"
        >
            <CompassButton
                size="large"
                :label="$t.__('common.actions.contact_sales')"
                @click="contactSale"
            />
            <p class="typographies-paragraph-medium-bold help-message__container">
                {{ $l10n.__('Revenir sur') }}
                <CompassLink
                    :label="$t.__('common.labels.sellsy_short_url')"
                    link="https://go.sellsy.com"
                />
            </p>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';

export default {
    components: {
        TrialEndClock,
    },
    methods: {
        contactSale() {
            window.Intercom('show');
        },
    },
};
</script>
<style scoped>
.help-message__container {
    margin: 0;
}
</style>
